/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/**
 * Get inventory sorting value based on channelInventoryConfiguration
 *
 * @param context The current action context
 * @param channelInventoryConfiguration The channelInventoryConfiguration
 */
export const getInventorySorting = channelInventoryConfiguration => {
    let sorting;
    if (channelInventoryConfiguration && channelInventoryConfiguration.ProductAvailabilitySortableAttributeRecordId) {
        const sortColumnName = `Attr_${channelInventoryConfiguration.ProductAvailabilitySortableAttributeRecordId}`;
        sorting = {
            Columns: [
                {
                    ColumnName: sortColumnName,
                    IsDescending: true
                }
            ]
        };
    }
    return sorting;
};
